import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import "../styles/MemberDetails.css";
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineLocationOn, MdUpdate } from "react-icons/md";

function MemberDetails() {
  
  const location = useLocation();
  const member = location.state?.member;
  const navigate = useNavigate();

  if (!member) {
    return <p style={{ padding: "30px" }}>No more data available.</p>;
  }

  const goToWallet = () => {
      navigate('/member-wallet-details', {state: {member}})
  }

  const goToRequestHistory = () => {
      navigate('/member-cash-request-history', {state: {member}})
  }

  const goToEdit = () => {
    navigate("/edit-member-profile", {state: {member}})
  }

  return (
    <div className="member-details-layout">
      <SideBar />

      <div className="member-details-main">

        {/* Header */}
        <div className="details-header">
          <h2>Member Details</h2>
          <p>You can edit your details to update your profile</p>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/dashboard" className="breadcrumb-link">Home</Link>
          <span className="breadcrumb-separator">{">"}</span>
          <Link to="/manage-member" className="breadcrumb-link">Manage Member</Link>
          <span className="breadcrumb-separator">{">"}</span>
          <span className="breadcrumb-current">Member Details</span>
        </div>

        {/* buttons */}
        <div className="top-bar">
          {/* tap buttons */}
          <div className="top-buttons">
            <button className="tab-btn active">Personal Details</button>
            <button className="tab-btn" onClick={goToWallet}>Wallet Details</button>
            <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
          </div>
        </div>

        {/* edit button */}
        {/* <div className="edit-btn-wrap">
          <button className="edit-btn">Edit</button>
        </div> */}

        {/* Basic Details */}
        <div className="section">
          {/* edit button */}
          <div className="edit-btn-wrap">
            <button className="edit-btn" onClick={goToEdit}>Edit</button>
          </div>
          <h3><FaRegUserCircle /> Basic Details</h3>
          <div className="section-content">
            <p><strong>First name:</strong> {member.firstName}</p>
            <p><strong>Surname:</strong> {member.surname}</p>
            <p><strong>Email:</strong> {member.email}</p>
            <p><strong>Mobile:</strong> {member.mobile}</p>
          </div>
        </div>

        {/* Address */}
        <div className="section">
          <h3><MdOutlineLocationOn /> Address</h3>
          <div className="section-content">
            <p><strong>Address line 1:</strong> {member.address.line1}</p>
            <p><strong>Address line 2:</strong> {member.address.line2}</p>
            <p><strong>Address line 3:</strong> {member.address.line3}</p>
            <p><strong>City:</strong> {member.address.city}</p>
            <p><strong>Region:</strong> {member.address.county}</p>
            <p><strong>Postcode:</strong> {member.address.postcode}</p>
            <p><strong>Country:</strong> {member.address.country}</p>
            
          </div>
        </div>

        {/* Status */}
        <div className="section">
          <h3><MdUpdate /> Status</h3>
          <div className="section-content">
            <p><strong>Email Status:</strong> {member.status}</p>
            <p><strong>Notes:</strong> {member.notes}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberDetails;
